import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import {
  Container,
  Flex,
  Box,
  Text,
  Heading,
  SubHeading,
} from "../components/layoutComponents";
import BackgroundImg from "../components/backgroundImg";
import Layout from "../components/layout";

const Lounas = ({ data }) => (
  <Layout>
    <Helmet>
      <title>Lounas - Ravintola Piha</title>
    </Helmet>

    <Container maxWidth={1440} p={0}>
      <BackgroundImg
        ratio={1 / 2}
        mobileRatio={1 / 2}
        sizes={data.contentfulPage.featuredImage.sizes}
      />
    </Container>

    <Container p={[3, null, 4]}>
      <Heading
        textAlign="center"
        mb={4}
        children={data.contentfulPage.title.title}
      />

      <Flex flexWrap="wrap" justifyContent="center" mx={[null, -2]}>
        {data.contentfulPage.contentBlocks &&
          data.contentfulPage.contentBlocks.map((node, i) => (
            <Box width={[1, 1 / 2, 1 / 3]} p={[null, 2]} key={node.id}>
              <SubHeading
                textAlign="center"
                children={node.title && node.title}
              />
              <Text
                textAlign="center"
                mb={4}
                dangerouslySetInnerHTML={{
                  __html: node.body.childMarkdownRemark.html,
                }}
              />
            </Box>
          ))}
      </Flex>
    </Container>

    <Container px={[3, null, 4]} mb={5}>
      <Text
        textAlign="center"
        dangerouslySetInnerHTML={{
          __html: data.contentfulPage.body.childMarkdownRemark.html,
        }}
      />
    </Container>
  </Layout>
);

export default Lounas;

export const pageQuery = graphql`
  query LounasQuery {
    contentfulPage(slug: { eq: "lounas" }) {
      title {
        title
      }
      slug
      body {
        childMarkdownRemark {
          html
        }
      }
      featuredImage {
        sizes(maxWidth: 1600, quality: 60) {
          base64
          aspectRatio
          src
          srcSet
          sizes
        }
      }
      contentBlocks {
        id
        title
        body {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`;
